/**
 * Design System Yoco - Tokens Typographie
 *
 * REGLES:
 * - Utiliser Futuru pour headings (h1-h6)
 * - Utiliser Inter pour body et UI
 * - Tailles en rem pour accessibilite
 * - fontWeight: 400 (regular), 500 (medium), 600 (semibold), 700 (bold)
 */

// ==============================================
// FONT FAMILY
// ==============================================
export const fontFamily = {
  heading: '"Futuru", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  body: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  mono: '"JetBrains Mono", "Fira Code", monospace',
};

// ==============================================
// FONT WEIGHTS
// ==============================================
export const fontWeight = {
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
};

// ==============================================
// FONT SIZES - Echelle coherente
// ==============================================
export const fontSize = {
  xs:   '0.6875rem',  // 11px - Labels tres petits, overline
  sm:   '0.75rem',    // 12px - Caption, small text
  base: '0.8125rem',  // 13px - Body default, inputs, buttons
  md:   '0.875rem',   // 14px - Body large
  lg:   '1rem',       // 16px - Section titles
  xl:   '1.125rem',   // 18px - Card titles
  '2xl': '1.25rem',   // 20px - Page titles
  '3xl': '1.5rem',    // 24px - H1 titles
};

// ==============================================
// LINE HEIGHTS
// ==============================================
export const lineHeight = {
  tight: 1.25,
  normal: 1.5,
  relaxed: 1.625,
};

// ==============================================
// FONT SIZES MOBILE - Plus grand pour lisibilite tactile
// ==============================================
export const fontSizeMobile = {
  xs:   '0.75rem',    // 12px - Labels tres petits
  sm:   '0.8125rem',  // 13px - Caption, small text
  base: '0.875rem',   // 14px - Body default (vs 13px desktop)
  md:   '1rem',       // 16px - Body large
  lg:   '1.125rem',   // 18px - Section titles
  xl:   '1.25rem',    // 20px - Card titles
  '2xl': '1.5rem',    // 24px - Page titles (vs 20px desktop)
  '3xl': '1.75rem',   // 28px - H1 titles
};

const typography = { fontFamily, fontWeight, fontSize, fontSizeMobile, lineHeight };
export default typography;
